import type React from 'react';
import { Badge } from '@/components/UI';
import type { CompareRow } from './types';

export function renderStageBadges(row: CompareRow): React.ReactNode {
    const { experimentId, experimentStageSummary, strategyStageSummary } = row;
    const badges: React.ReactNode[] = [];

    if (experimentStageSummary.hasScorecards) {
        badges.push(
            <Badge key="scorecards" variant="secondary">
                Experiment Scorecards {experimentStageSummary.scorecardCount}
            </Badge>
        );
    }

    if (strategyStageSummary.hasBacktests) {
        badges.push(
            <Badge key="backtests" variant="info">
                Strategy Backtests {strategyStageSummary.backtestCount}
            </Badge>
        );
    }

    if (strategyStageSummary.hasPortfolioBacktests) {
        badges.push(
            <Badge key="portfolioBacktests" variant="warning">
                Portfolio Backtests {strategyStageSummary.portfolioBacktestCount}
            </Badge>
        );
    }

    if (strategyStageSummary.hasPortfolio) {
        badges.push(
            <Badge key="portfolio" variant="success">
                In Current Portfolios {strategyStageSummary.portfolioCount}
            </Badge>
        );
    }

    if (strategyStageSummary.isCurrentChampion) {
        const championExperimentId = strategyStageSummary.currentChampionExperimentId;

        badges.push(
            <Badge key="champion" variant="danger">
                {championExperimentId === experimentId || championExperimentId === null ? 'Champion' : `Champion #${championExperimentId}`}
            </Badge>
        );
    }

    if (badges.length === 0) {
        return <span className="text-xs text-zinc-600">Strategy not promoted yet</span>;
    }

    return <div className="flex flex-wrap gap-1.5">{badges}</div>;
}
